export enum GoogleAnalyticsEventType {
  AddToCart = 'addToCart',
  Checkout = 'checkout',
  Transaction = 'transaction',
  Custom = 'custom',
  ConfirmToDispatch = 'confirm_dispatch',
  ReadyToReceive = 'ready_to_receive',
  DeletePod = 'delete_POD',
  PODCreationFail = ' POD_creation_fails',
  PODCreationSuccess = 'POD_creation_success',
  PrefillButton = 'prefill_button',
}

export enum GoogleAnalyticsEventLabel {
  OrderStep_ProductLine = 'Product Line',
  OrderStep_Location = 'Location',
  OrderStep_Specifications = 'Specifications',
  OrderStep_Review = 'Review',
  OrderStep_Summary = 'Summary',
  OrderStep_FinalStep = 'Final Step',
  AddToCart = 'Add to cart',
  OrderStep_Success = 'Step Status Successful',
  OrderStep_Error = 'Step Status Error',
  NoAvailability = 'No Availability',
  S2Orders = 'S2 – Orders',
  OrderDetail = 'Order Detail',
  CalendarView = 'Calendar View',
  ListView = 'List View',
  NewOrder = 'Order Creation',
  MultipleOrder = 'Multiple Order Creation',
}

export enum GoogleAnalyticsEventAction {
  OrderRequest = 'New Order Request',
  AddToCart = 'Add to cart',
  Error = 'Error',
  Transaction = 'Transaction',
  OnHoldOrder = 'On Hold Order',
  Rejected = 'Rejected',
  Successful = 'Successful',
  ResumeOrder = 'Resume Order',
  CancelOrder = 'Cancel Order',
  RepeatOrder = 'Repeat Order',
  DownloadOrderConfirmation_Excel = 'Excel',
  DownloadOrderConfirmation_Email = 'Email',
  DownloadOrderConfirmation_ExcelAndEmail = 'Excel|Email',
  ModifyOrder = 'Modify Order',
  AdjustOrder = 'Adjustment Order',
}

export enum GoogleAnalyticsEventCategory {
  Ecommerce = 'Ecommerce',
  NewOrder = 'S2 - Orders',
  ModifyOrder = 'S2 - Orders',
  HoldOrder = 'S2 - Hold Order',
  ResumeOrder = 'S2 - Resume Order',
  CancelOrder = 'S2 - Cancel Order',
  Downloads = 'S2 - Downloads',
  Adjustments = 'S2 - Adjustment Orders',
}

export interface GoogleAnalyticsEvent {
  event: String;
  eventCategory: GoogleAnalyticsEventCategory;
  eventAction: GoogleAnalyticsEventAction;
  eventLabel: GoogleAnalyticsEventLabel | string;
  [key: string]: any;
}

export interface PrefillButtonEvent {
  event: GoogleAnalyticsEventType.PrefillButton;
  userId: string;
  countryCode: string;
  customerId: string;
  userSegment: string;
  userSubsegment: string;
  userCategory: string;
  userType: string;
  pagePath: string;
  pageTitle: string;
  application: string;
  jobsiteCode: string;
}

export type GoogleAnalyticsEventStatus = 'intent' | 'error' | 'success';

export const DimensionNilValue = 'NA';
